import {isAuthenticated} from '../services/Authentication.service';
import Authentication from '../components/g_authentication/Authentication';

export default {
  path: '/',
  name: 'Authentication',
  component: Authentication,
  beforeEnter: (to, from, next) => {
    let role = localStorage.getItem('role');

    if (isAuthenticated()) {
      if (role == 'admin') {
        next({name: 'GlobalAdministration'});
      } else {
        next({name: 'GeneralDashboard'});
      }
    } else {
      next();
    }
  }
};






// WEBPACK FOOTER //
// ./src/router/Authentication.router.js